<template>
  <!--Binds the color for the variant of the icon based on the status from nereus-->
  <!--Hover text that displays what the status is from nereus-->
  <div>
    <b-btn
      class="multi-text-color"
      pill
      :variant="getStatusHelper()"
      :href="nereus_url"
      target="_blank"
    >
      <i
        v-if="iconValue"
        class="material-icons multi-icon-color"
      >{{getStatusIndicatorIcon()}}
      </i>
      {{getStatusIndicatorText()}}
    </b-btn>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { iconNames } from '../../utils/constants';

export default {
  props: ['infraRD'],
  data() {
    return {
      nereus_url: `${process.env.NEREUS}/help/codes`,
      iconValue: true, // sets the light colored icons
    };
  },
  computed: {
    ...mapState({
      infraIndicators: (state) => state.infraIndicators,
    }),
  },
  methods: {
    // Helper method to filter through the statusIndicator information
    getStatusHelper() {
      const infraSubstring = this.infraRD.slice(9, 14);
      let statusValue = _.get(this.infraIndicators, infraSubstring);
      if (_.isEmpty(statusValue)) {
        statusValue = 'unset';
      }
      return statusValue.toLowerCase();
    },
    // Takes the status information and displays "Status" text
    getStatusIndicatorText() {
      const statusHolderText = this.getStatusHelper();
      const newStr = statusHolderText.replace(/-|_/g, ' ');
      let text;
      if (_.isEmpty(statusHolderText)) {
        text = 'No status available';
      } else {
        text = newStr[0].toUpperCase() + newStr.substring(1);
      }
      return text;
    },
    // Takes the status information and displays "Status" text
    getStatusIndicatorIcon() {
      const statusHolder = this.getStatusHelper();
      return iconNames[statusHolder];
    },
  },
};
</script>

<style>
.multi-icon-color {
  color: white !important;
  font-size: 0.9rem !important;
}
.multi-text-color {
  color: white!important;
  font-size: 0.8rem !important;
  line-height: 0.1 !important;
  padding: 0.2rem 0.5rem 0.3rem !important;
}
/* Different variants for the button based on status frorm nereus */
.btn-operational {
  background-color: #00923a !important;
}
.btn-uncabled {
  background-color: #bdbdbd !important;
}
.btn-partiallyFunctional {
  background-color: #ff6e40 !important;
}
.btn-troubleshooting {
  background-color: #fbc02d !important;
}
.btn-data_quality {
  background-color: #f57c00 !important;
}
.btn-failed {
  background-color: #c10015 !important;
}
.btn-offline {
  background-color: #9e9e9e !important;
}
.btn-not_deployed {
  background-color: #424242 !important;
}
.btn-unset {
  background-color: #9e9e9e !important;
}
.btn-default {
  background-color: #000000 !important;
}
</style>
